import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CompanyService from '@/services/CustomersServices/CompanyService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    submitting: false,
    errors: null,
    successOnCreate: '',
    loading: false,
};

export const viewCompany = createAsyncThunk(
    'company/viewCompany',
    async (companyId, { rejectWithValue }) => {
        try {
            const response = await CompanyService.viewCompany(companyId);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const createCompany = createAsyncThunk(
    'company/createCompany',
    async (data, { rejectWithValue }) => {
        try {
            const { id: companyId } = data;
            let response;
            if (companyId) {
                response = await CompanyService.updateCompany(data, companyId);
            } else {
                response = await CompanyService.createCompany(data);
            }
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const createCompanySlice = createSlice({
    name: 'createCompany',
    initialState: model,
    reducers: {
        resetCompanyState: (state) => {
            state.data = null;
            state.errors = null;
        },
        resetCompanyStateOnError: (state) => {
            state.errors = null;
        },
        resetCompanyStateOnSuccess: (state) => {
            state.successOnCreate = '';
        },
    },
    extraReducers: (builder) => {
        // view company
        builder.addCase(viewCompany.pending, (state) => {
            state.loading = true;
        }).addCase(viewCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewCompany.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // create company
        builder.addCase(createCompany.pending, (state) => {
            state.submitting = true;
        }).addCase(createCompany.fulfilled, (state, action) => {
            state.submitting = false;
            const companyId = action.meta.arg.id;
            state.successOnCreate = companyId ? 'Company updated successfully!' : 'Company created successfully!';
        }).addCase(createCompany.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetCompanyState,
    resetCompanyStateOnError,
    resetCompanyStateOnSuccess,
} = createCompanySlice.actions;

export default createCompanySlice.reducer;
